export enum PractitionerAccountStatus {
    activated = 'activated',
    notActivated = 'notActivated',
    terminated = 'terminated',
}
